import { Fragment } from "react";
import { Outlet, Route, isRouteErrorResponse, useRouteError } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Slugs } from "src/context/ProtectedContext";
import { useFoodpilotContext, DASHBOARD, VIEW_DASHBOARD } from "src/context/FoodpilotContext";
import { Forbiddenpage } from "src/components/PageState/ForbiddenPage";
import SupersetDashboard from "src/pages/Superset/SupersetDashboard.tsx";

export const useSupersetRouter = () => {
    return (
        <Fragment>
            <Route path="superset" errorElement={<SupersetError />}>
                <Route element={<SupersetActionProtection slug={VIEW_DASHBOARD} />}>
                    <Route index element={<SupersetDashboard />} />
                </Route>
            </Route>
        </Fragment>
    );
};

type SupplierActionProtectionProps = {
    slug: Slugs;
};
const SupersetActionProtection = (props: SupplierActionProtectionProps) => {
    const { slug } = props;
    const { canUser } = useFoodpilotContext();

    if (!canUser(slug, DASHBOARD)) {
        return <Forbiddenpage />;
    }

    return <Outlet />;
};

const SupersetError = () => {
    const { t } = useTranslation();
    const error = useRouteError();
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            return <div>{t("Page inexistante")} 404</div>;
        } else if (error.status === 401) {
            return <div>{t("Unauthorized")}: 401</div>;
        } else if (error.status === 503) {
            return <div>API down: 503</div>;
        } else if (error.status === 500) {
            return <div>API error: 500</div>;
        }
    }

    return <div>Superset error</div>;
};
